<template>
  <!-- 聊天 互动 -->
  <div>
    <div class="top_tit">
      <div class="line"></div>
      <p>{{ interactive.Name }}</p>
    </div>
    <div v-if="interactive.InteractionContents" class="bottom_content">
      <div
        v-if="interactive.InteractionContents.length > 0"
        id="lt_cont"
        class="lt_cont"
      >
        <div
          v-for="d in interactive.InteractionContents"
          :key="d.ModuleInstanceId"
        >
          <div :class="d.IsMentee ? 'ask_list_r' : 'ask_list_l'">
            <div class="data">{{ dateFormat(d.CreationDate) }}</div>
            <div v-if="d.Content" class="cont_box">
              <div v-if="d.IsMentee !== true" class="atilce">
                <van-image
                  fit="cover"
                  height="40"
                  :src="api.FileHost + d.Avatar"
                  width="40"
                >
                  <template #error>导师</template>
                </van-image>
              </div>
              <div v-if="d.Content" class="content_box">
                <span v-html="hhText(d.Content)"></span>
                <van-icon class="content_box_icon" name="play" />
              </div>

              <div v-if="d.IsMentee" class="atilce">
                <van-image
                  fit="cover"
                  height="40"
                  :src="api.FileHost + d.Avatar"
                  width="40"
                >
                  <template #error>我</template>
                </van-image>
              </div>
            </div>

            <div v-if="d.Images.length > 0" class="cont_box">
              <div v-if="d.IsMentee !== true" class="atilce">
                <van-image
                  fit="cover"
                  height="40"
                  :src="api.FileHost + d.Avatar"
                  width="40"
                >
                  <template #error>导师</template>
                </van-image>
              </div>

              <div v-if="d.Images.length > 0" class="img_box">
                <img
                  v-for="(img, i) in d.Images"
                  :key="i + 'img'"
                  alt=""
                  :src="api.FileHost + img"
                  style="width: 150px; border: 1px solid #eee"
                  @click.stop="showImg(d.Images, i)"
                />
              </div>
              <div v-if="d.IsMentee" class="atilce">
                <van-image
                  fit="cover"
                  height="40"
                  :src="api.FileHost + d.Avatar"
                  width="40"
                >
                  <template #error>我</template>
                </van-image>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else style="font-size: 12px; text-align: center; color: #888">
        暂无互动~~
      </div>
      <div v-if="state1 == 10 && nodestatus == 20" class="bottom_kj">
        <div class="bottom_kj_input_box">
          <img v-if="!inputBlur" alt="" src="@/assets/images/bj.png" />
          <van-cell-group :class="inputBlur ? 'van_group' : ''" inset>
            <van-field
              v-model="bodyData.content"
              autosize
              placeholder="我要提问"
              rows="1"
              type="textarea"
              @blur="goBlur"
              @focus="goFocus"
            />
          </van-cell-group>
          <div class="add_icon_box">
            <van-icon class="add_icon" name="add-o" />
            <zy-uploader
              class="input_add"
              :limit-size="500 * 1024"
              :max-count="9"
              :max-size="10 * 1024 * 1024"
              @getImgList="(val) => getImg(val, index)"
              @send="send(interactive.ModuleInstanceId)"
            />
          </div>
        </div>
        <div class="bottom_kj_btn" @click="send(interactive.ModuleInstanceId)">
          发送
        </div>
      </div>
    </div>
  </div>
  <!-- <div v-if="tel.length == '0'" class="list_box">
    <div class="top_tit">
      <div class="line"></div>
      <p>课堂互动</p>
    </div>
    <div class="bottom_content">
      <van-empty description="暂无课堂互动" image-size="40" />
    </div>
  </div> -->
</template>

<script>
  import {
    nextTick,
    onMounted,
    onUnmounted,
    onUpdated,
    reactive,
    ref,
    toRefs,
    watch,
  } from 'vue'
  import { hhText } from '@/utils/index'
  import router from '@/router'
  import ZyUploader from '@/components/ZyUploaderhd'
  import { dateFormat } from '@/utils/filters'
  import { Toast, ImagePreview } from 'vant'
  import { useRouter, useRoute } from 'vue-router'
  import api from '@/api'
  import store from '@/store'
  export default {
    components: {
      ZyUploader,
    },
    props: {
      // eslint-disable-next-line vue/require-default-prop
      interactive: {
        type: Object,
      },
      // eslint-disable-next-line vue/require-default-prop
      state1: {
        type: Number,
      },
      // eslint-disable-next-line vue/require-default-prop
      nodestatus: {
        type: Number,
      },
    },
    emits: ['mm'],
    setup(props, context) {
      const inputBlur = ref(false)
      const route = useRoute()
      const afterRead = (file) => {
        // 此时可以自行将文件上传至服务器
        //console.log(file)
      }
      const bodyData = ref({
        moduleInstanceId: null,
        content: '',
        images: [],
      })
      onMounted(() => {
        scrollToBottom()
        // if (props.interactive) {
        //   props.interactive.bodyData = {
        //     moduleInstanceId: null,
        //     content: '',
        //     images: [],
        //   }
        // }
      })
      onUpdated(() => {
        scrollToBottom()
      })

      const showImg = (list, index) => {
        const arr = []
        list.forEach((item) => {
          arr.push(api.FileHost + item)
        })
        ImagePreview({
          images: arr,
          startPosition: index,
          showIndex: false,
          showIndicators: true,
          overlayStyle: {
            background: '#000',
          },
          //closeable: true,
        })
      }
      const scrollToBottom = () => {
        var container = document.getElementsByClassName('lt_cont')
        if (container) {
          for (let i = 0; i < container.length; i++) {
            container[i].scrollTop = container[i].scrollHeight
          }
        }
      }
      const getImg = (val, index) => {
        // console.log('233333 :>> ', val, index)
        bodyData.value.images.push(val)
      }
      const send = (mid) => {
        if (bodyData.value.content == '' && bodyData.value.images.length <= 0) {
          Toast('请输入要发送的内容')
          return
        }
        menteeSendMsg(mid)

        bodyData.value.content = ''
        bodyData.value.images = []
        inputBlur.value = false
      }
      const goFocus = () => {
        inputBlur.value = true
      }
      const goBlur = () => {
        if (bodyData.value.content == '') {
          inputBlur.value = false
        }
      }
      // const goBlur = () => {
      //   inputBlur.value = false
      //   bodyData.value.content = ''
      //   bodyData.value.images = []
      // }
      //学员发送互动消息接口
      const menteeSendMsg = (moduleInstanceId) => {
        const params = bodyData.value
        params.formId = route.params.id
        params.moduleInstanceId = moduleInstanceId
        //console.log('bodyData.value :>> ', bodyData.value)
        store
          .dispatch('service/MenteeSendMsg', bodyData.value)
          .then((res) => {
            if (res.Code === 0) {
              //console.log('res :>> ', res)
              context.emit('mm', { keyName: 'I am value' })
            }
          })
          .catch((e) => {
            Toast.fail(e.Message || '发布失败')
          })
      }

      return {
        send,
        afterRead,
        onMounted,
        scrollToBottom,
        getImg,
        menteeSendMsg,
        dateFormat,
        showImg,
        bodyData,
        inputBlur,
        goFocus,
        goBlur,
        hhText,
      }
    },
    data() {
      return {
        api,
      }
    },
  }
</script>

<style lang="scss" scoped>
  .imgzs {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    img {
      width: 40px;
      height: 40px;
      border: 1px solid #ccc;
    }
  }
  .van-cell-group--inset {
    /* margin: var(--van-cell-group-inset-padding); */
    margin: 0 !important;
    border-radius: 4px !important;
    border: 1px solid #ccc !important;
    background-color: transparent !important;
    padding-left: 25px !important;
    padding-right: 25px !important;
  }
  .van-cell {
    line-height: 16px !important;
  }
  .content_tck {
    ul {
      padding: 30px 15px;
      li {
        position: relative;
        width: 25%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border: 1px solid #eee;
        img {
          width: 60px;
        }
        .input {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          border: 1px solid red;
          opacity: 0;
        }
      }
    }
  }
  input::placeholder {
    font-size: 15px;
    font-family: 'Source Han Sans CN';
    font-weight: 400;
    color: #dbdbdd;
  }
  .bottom_content {
    position: relative;
    padding-bottom: 30px;
    padding-top: 20px;
    .lt_cont {
      background-color: #efeff3;
      padding: 20px 15px;
      border-radius: 8px;
      max-height: 380px;
      overflow-y: auto;
    }

    .ask_list_l {
      margin-bottom: 16px;
      .img_box {
        margin-left: 15px;
      }
      .data {
        font-size: 12px;
        color: #bebec1;
        text-align: center;
        padding: 8px 0;
      }
      .cont_box {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        margin-bottom: 10px;
        .atilce {
          width: 40px;
          height: 40px;
          min-width: 40px;
          border-radius: 4px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .content_box {
          word-break: break-all;
          max-width: 80%;
          margin-left: 10px;
          background-color: #fff;
          border: 1px solid #eee;
          border-radius: 5px;
          padding: 10px 20px;
          position: relative;
          box-sizing: border-box;
          box-shadow: 0px 0px 10px 0px rgba(232, 232, 233, 0.88);
          font-size: 12px;
          font-family: 'Source Han Sans CN';
          font-weight: 400;
          color: #333333;
          line-height: 18px;
          .content_box_icon {
            position: absolute;
            top: 4px;
            left: -11px;
            font-size: 24px;
            color: #fff;
            transform: rotate(180deg);
            -ms-transform: rotate(180deg); /* IE 9 */
            -moz-transform: rotate(180deg); /* Firefox */
            -webkit-transform: rotate(180deg); /* Safari 和 Chrome */
            -o-transform: rotate(180deg); /* Opera */
          }
        }
      }
    }
    .ask_list_r {
      margin-bottom: 16px;
      .img_box {
        margin-right: 15px;
        img {
          width: 100px;
        }
      }
      .data {
        font-size: 12px;
        color: #bebec1;
        text-align: center;
        padding: 8px 0;
      }
      .cont_box {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: flex-start;
        margin-bottom: 10px;
        .atilce {
          width: 40px;
          height: 40px;
          border-radius: 4px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .content_box {
          word-break: break-all;
          max-width: 80%;
          min-height: 34px;
          background-color: #96eb68;
          border-radius: 5px;
          border: 1px solid #eee;
          padding: 10px 20px;
          position: relative;
          box-sizing: border-box;
          box-shadow: 0px 0px 10px 0px rgba(232, 232, 233, 0.88);
          font-size: 12px;
          margin-right: 10px;
          line-height: 18px;
          font-family: 'Source Han Sans CN';
          font-weight: 400;
          line-height: 18px;
          color: #333333;
          word-wrap: break-word;
          .content_box_icon {
            position: absolute;
            top: 4px;
            right: -11px;
            font-size: 24px;
            color: #96eb68;
          }
        }
      }
    }
  }
  .btn {
    width: 90%;
    height: 32px;
    background-color: #b57e48;
    border-radius: 4px;
    text-align: center;
    line-height: 32px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    margin: 0 0 15px 0;
    position: absolute;
    bottom: 0px;
    left: 5%;
  }
  .bottom_kj {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 22px;
    .bottom_kj_input_box {
      width: 80%;
      position: relative;
      img {
        width: 20px;
        position: absolute;
        top: 6px;
        left: 7px;
      }
      .bottom_kj_input {
        width: 100%;
        height: 32px;
        padding-left: 28px;
        padding-right: 28px;
        background: #fcfcfc;
        border: 1px solid #e8e8e9;
        border-radius: 4px;
        white-space: pre-line; //合并空白符序列，但是保留换行符
        word-wrap: break-word; //在长单词或 URL 地址内部进行换行。
      }
      .add_icon_box {
        width: 26px;
        height: 26px;
        position: absolute;
        bottom: 8px;
        right: 7px;
        .add_icon {
          font-size: 26px;
          color: #e8e8e9;
        }
        .input_add {
          width: 26px;
          height: 26px;
          position: absolute;
          top: 0;
          left: 0;
          opacity: 0;
        }
      }
    }

    .bottom_kj_btn {
      width: 18%;
      height: 40px;
      background: #b57e48;
      border-radius: 4px;
      color: #fff;
      font-size: 14px;
      line-height: 40px;
      text-align: center;
    }
  }
  .van_group {
    padding-left: 0 !important;
  }
</style>
